import { IWord } from "./word-ref.model";

export class Word implements IWord {

    id: string;
    base: string;
    forms: Form[]

    get displayText(): string {
        return this.base;
    }
}

class Form {
    id: string
    text: string
    meanings:Meaning[]
}

class Meaning {
    text: string
    example:string
}